<template>
  <div class="bookingform-list">
    <h2>Booking CC List</h2>
    <button class="btn btn-primary mb-4" @click="addCurrencyConvert">Add New Booking CC</button>
    <v-client-table
      :data="filteredCurrencyConverts"
      :columns="columns"
      :options="options"
      @row-click="showCurrencyConvert"
    ></v-client-table>
  </div>
</template>
  
  <script>
  const api = window.api;
  
  export default {
    name: "BookingCCList",
    data() {
      return {
        currencyConverts: [],
        search: "",
        columns: ["id", "Reference", "ToCurrency", "ConvertValue"],
        options: {
          headings: {
            Reference: "Reference",
            ToCurrency: "To Currency",
            ConvertValue: "Convert Value",
          },
          sortable: ["id", "Reference", "ToCurrency", "ConvertValue"],
          filterable: ["id", "Reference", "ToCurrency", "ConvertValue"],
          perPage: 10,
          perPageValues: [10, 20, 50],
          skin: "table table-striped table-hover",
        },
      };
    },
    computed: {
      filteredCurrencyConverts() {
        if (!this.currencyConverts)  return []
        if (!this.search) return this.currencyConverts;
          
        const searchLower = this.search?.toLowerCase();
        return this.currencyConverts.filter((convert) => {
          return (
            convert.id?.toString().toLowerCase().includes(searchLower) ||
            convert.FromCurrency?.toLowerCase().includes(searchLower) ||
            convert.ToCurrency?.toLowerCase().includes(searchLower) ||
            convert.ConvertValue?.toString().includes(searchLower)
          );
        });
      },
    },
    mounted() {
      this.fetchCurrencyConverts();
    },
    methods: {
      async fetchCurrencyConverts() {
        this.currencyConverts = await api.get("/api/bookingcc/");
      },
      showCurrencyConvert(data) {
        this.$router.push({ name: "bookingcc", params: { id: data.row.id } });
      },
      addCurrencyConvert() {
        this.$router.push({name: 'bookingcc', params: {id: null}})
      },
    },
  };
  </script>
  
  <style scoped>
  .bookingform-list {
    margin: 20px;
  }
  .mb-4 {
    margin-bottom: 16px;
  }
  </style>
  